import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const rm = (n) => `RM${Number(n || 0).toFixed(2)}`;
export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || e?.message || "Ralat berlaku";

const MENU_KEY = "alfaz_menu";
export const cachedMenu = () => { try { return JSON.parse(localStorage.getItem(MENU_KEY) || "[]"); } catch { return []; } };
export const fetchMenu = () => api.get("/menu").then((r) => {
  try { localStorage.setItem(MENU_KEY, JSON.stringify(r.data)); } catch { /* storage full */ }
  return r.data;
});

export const STATUS = {
  baharu: { label: "Baharu", cls: "bg-amber-500 text-white" },
  proses: { label: "Sedang Proses", cls: "bg-blue-500 text-white" },
  selesai: { label: "Selesai", cls: "bg-green-500 text-white" },
  batal: { label: "Dibatalkan", cls: "bg-rose-500 text-white" },
};

export const timeMY = (iso) =>
  new Date(iso).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kuala_Lumpur" });

export const DAYS = ["Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu", "Ahad"];
const toMins = (hm, d) => (hm ? Number(hm.slice(0, 2)) * 60 + Number(hm.slice(3, 5)) : d);

export function timeSlots(hours) {
  const slots = [];
  const nowMs = Date.now() + 8 * 3600000;
  const base = new Date(nowMs);
  base.setUTCHours(0, 0, 0, 0);
  const on = hours?.hours_enabled;
  const start = on ? toMins(hours.open_time, 600) : 600;
  const end = on ? toMins(hours.close_time, 1320) : 1320;
  for (let d = 0; d < 2; d++) {
    const pyDay = (new Date(base.getTime() + d * 86400000).getUTCDay() + 6) % 7;
    if (on && hours.closed_days?.includes(pyDay)) continue;
    for (let mins = Math.ceil(start / 15) * 15; mins < end; mins += 15) {
      const t = base.getTime() + d * 86400000 + mins * 60000;
      if (t < nowMs + 20 * 60000) continue;
      const h = Math.floor(mins / 60), m = String(mins % 60).padStart(2, "0");
      const hh = `${String(((h + 11) % 12) + 1).padStart(2, "0")}:${m} ${h < 12 ? "AM" : "PM"}`;
      slots.push(`${d === 0 ? "Hari ini" : "Esok"}, ${hh}`);
    }
  }
  return slots;
}
